import React, { useEffect, useState } from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';
import Button from "../../Components/common/Button";

import TextField from '../common/TextField';
import Loader from '../../Layout/Loader';
import { checkPrivileges } from '../../Helpers';
import withTranslationWrapper from '../../HOC/HocTranslate';
import { connect } from 'react-redux';
import Table from "../../Components/common/tableWithBackEndPagination";
import ExportFile from '../common/ExportFile';
import ConfirmDialoag from '../common/ConfirmDialoag';
import instance from '../../axios';
import { toast } from 'react-toastify';
import Checkbox from "../common/Checkbox";


const MismatchedDeliveryNotes = (props) => {
  const {
    translate,
    plateNumber,
    searchInvoices,
    getInvoices,
    loader,
    misMatchedDeliveryNoteList,
    setMismatchedDnsPagination,
    handleChangePage,
    handleChangeRowsPerPage,
    logInUser,
    goBack,
    to,
    from,
    page,
    limit,
    dispatch
  } = props;
  
const options = [
  {
    key: "Battery Service with in 365 Days",
    text: props.translate(
      "Battery Service with in 365 Days"
    ),
  },
  {
    key: "Mileage is wrong in this invoice",
    text: props.translate(
      "Mileage is wrong in this invoice"
    ),
  },
  {
    key: "Repeated Invoice of same vehicle",
    text: props.translate(
      "Repeated Invoice of same vehicle"
    ),
  },
  {
    key: "Vehicle not belonged to this account",
    text: props.translate(
      "Vehicle not belonged to this account"
    ),
  },
  {
    key: "Early service",
    text: props.translate(
      "Early service"
    ),
  },
  {
    key: "Price Variations",
    text: props.translate(
      "Price Variations"
    ),
  },
  {
    key: "Other",
    text: props.translate(
      "Other"
    ),
  }
];
  const [state, setState] = useState({
    isShowChecboxesTable: false,
    selectedIds: [],
    displayedItems: [],
    hasToCheckAll: false

  })

  const handleOpenRejectedDnModals = () => {
    setState((prevState) => ({
      ...prevState,
      isOpenRejectedDnModal: true
    }))
  }
  const handleSelectedDn = () => {
    const updatedPageItems = state.displayedItems.map(item => ({
      ...item,
      checked: false
    }));
    setState((prevState) => ({
      ...prevState,
      isShowChecboxesTable: !prevState.isShowChecboxesTable,
      selectedIds: [],
      displayedItems: updatedPageItems,
      hasToCheckAll: false
    }))
  }
  const updateItemsWithCheckedStatus = (newItems) => {
    const { selectedIds } = state;

    const updatedItems = newItems.map(item => {
      const isChecked = selectedIds.some(selected => selected.id === item.id);
      return { ...item, checked: isChecked };
    });
    setState((prevState) => ({
      ...prevState,
      displayedItems: updatedItems,
      hasToCheckAll: updatedItems.every(item => item.checked) && updatedItems.length > 0
    }))
  };

  useEffect(() => {
    updateItemsWithCheckedStatus(misMatchedDeliveryNoteList?.data || []);
  }, [misMatchedDeliveryNoteList?.data])

  const handleCheckboxClick = (clickedItem) => {
    setState((prevState) => {
      const isAlreadyChecked = prevState.selectedIds.some(item => item.id === clickedItem.id);
      const updatedSelectedIds = isAlreadyChecked
        ? prevState.selectedIds.filter(item => item.id !== clickedItem.id)
        : [...prevState.selectedIds, clickedItem];

      const updatedDisplayedItems = prevState.displayedItems.map(item =>
        item.id === clickedItem.id ? { ...item, checked: !isAlreadyChecked } : item
      );
      const allChecked = updatedDisplayedItems.every(item => item.checked) && updatedDisplayedItems.length > 0;
      console.error("data", allChecked)
      return {
        ...prevState,
        selectedIds: updatedSelectedIds,
        displayedItems: updatedDisplayedItems,
        hasToCheckAll: allChecked
      };
    });
  };

  const handleAllCheckboxes = (e) => {
    const shouldCheckAll = e.target.checked;
    const allowedItems = state.displayedItems.filter(
      item => item.invoiceMade !== 1 && item.invoiceMade !== 4
    );

    const updatedPageItems = state.displayedItems.map(item => ({
      ...item,
      checked: shouldCheckAll && (item.invoiceMade !== 1 && item.invoiceMade !== 4)
    }));
    const updatedSelectedIds = shouldCheckAll
      ? [
        ...state.selectedIds.filter(
          sel => !state.displayedItems.some(item => item.id === sel.id)
        ),
        ...allowedItems
      ]
      : state.selectedIds.filter(
        sel => !state.displayedItems.some(item => item.id === sel.id)
      );
    setState((prevState) => ({
      ...prevState,
      displayedItems: updatedPageItems,
      selectedIds: updatedSelectedIds,
      hasToCheckAll: shouldCheckAll
    }))
  };

  const handleCloseRejectedDnModals = () => {
    setState((prevState) => ({
      ...prevState,
      isOpenRejectedDnModal: false

    }))
  }

  const handleSubmitRejectionDns = async () => {
    try {
      const apiPayload = {
        ids: state.selectedIds.map(item => item.id),
        message: state.rejectionMessage,
      };
      const data = await instance.post("/api/deliverynotes/rejectnotes", apiPayload);
      const uncheckedItems = state.displayedItems.map(item => ({
        ...item,
        checked: false,
      }));
      setState((prevState) => ({
        ...prevState,
        displayedItems: uncheckedItems,
        selectedIds: [],
        rejectionMessage: '',
        hasToCheckAll: false
      }))
      props.getInvoices();
      handleCloseRejectedDnModals()
      toast.success(data)
    } catch (error) {
      toast.error(error)
    }
  };

  const handleLoadMore = () => {
    setState((prevState) => ({
      ...prevState,
      visibleCount: prevState.visibleCount + 10
    }))
  };

  const handleCheckboxChange = (option) => {
    setState((prevState) => {
      const selectedOptions = Array.isArray(prevState.selectedOptions)
        ? prevState.selectedOptions
        : [];

      let updatedOptions;
      let updatedMessage = prevState.rejectionMessage || "";

      if (selectedOptions.includes(option.text)) {
        updatedOptions = selectedOptions.filter((item) => item !== option.text);
        const pattern = new RegExp(`\\b${option.text}\\b`, "gi");
        updatedMessage = updatedMessage.replace(pattern, "").replace(/\s+/g, " ").trim();
      } else {
        updatedOptions = [...selectedOptions, option.text];
        updatedMessage = (updatedMessage + " " + option.text).trim();
      }
      return {
        ...prevState,
        selectedOptions: updatedOptions,
        rejectionMessage: updatedMessage,
      };
    });
  };

  const handleRejectionMessage = (field, value) => {
    setState((prevState) => ({
      ...prevState,
      [field]: value
    }));
  };


  const formatLabel = (option) => {
    const [firstPart, ...rest] = option.text.split(":");
    return (
      <span>
        <strong>{firstPart}:</strong> {rest.join(":")}
      </span>
    );
  };

  const isDisabled = !state.rejectionMessage?.trim()
  return (
    <>
      <Grid>
        <Grid
          container
          className="breadcrumb-row"
          style={{ paddingLeft: 10, paddingRight: 10 }}
        >
          <Grid item xs={12} sm={3} justifyContent={"space-between"}>
            <h3 style={{ margin: 0 }}>
              {translate("misMatched")}
            </h3>
            {
              state.isShowChecboxesTable && state.selectedIds?.length > 0 &&
              <Button
                aria-label="search"
                size="small"
                color="inherit"
                onClick={handleOpenRejectedDnModals}
                id="search"
              >
                {translate("reject dns")}  ({state.selectedIds?.length > 99 ? '99+' : state.selectedIds?.length})
              </Button>
            }
          </Grid>

          <Grid item xs={12} sm={9} style={{ justifyContent: "flex-end" }}>
                        <div style={{ width: "25%", marginRight: 20 }}>
              <TextField
                fullWidth
                label={translate("searchdeliveryNoteNumber")}
                value={props.deliveryNoteNumber}
                onChange={(e) => props.searchInvoices(e, "deliveryNoteNumber")}
              />

            </div>

            <div style={{ width: "25%", marginRight: 20 }}>
              <TextField
                fullWidth
                label={translate("searchdeliveryNoteRefNumber")}
                value={props.deliveryNoteRefNumber}
                onChange={(e) => props.searchInvoices(e, "deliveryNoteRefNumber")}
              />
            </div>
          <div style={{ width: "25%", marginRight: 20 }}>
            <TextField
              fullWidth
              label={props.translate("plateNumber")}
              value={props.plateNumber}
              onChange={(e) => props.searchInvoices(e, "plateNumber")}
            />
          </div>
            <Button
              aria-label="search"
              size="small"
              color="inherit"
              onClick={props.getInvoices}
              id="search"
            >
              {translate("search")}
            </Button>
            <Button
              aria-label="Show"
              size="small"
              color="inherit"
              onClick={handleSelectedDn}
              id="Show"
              disabled={props.loader||state.displayedItems?.length===0}
              style={{ margin: 20 }}
            >
              {state.isShowChecboxesTable ? translate("unSelect") : translate("Select")}
            </Button>


            <Button
              aria-label="Back"
              size="small"
              color="inherit"
              onClick={props.goBack}
              id="back"
              style={{ margin: 10 }}
            >
              {translate("sharedBack")}
            </Button>
          </Grid>
        </Grid>

        <Grid>
          {loader ? <Loader /> : (
            <Table
              hasToCheckAll={state.hasToCheckAll}
              multiSelect={state.isShowChecboxesTable}
              handleCheckboxClick={handleCheckboxClick}
              handleAllCheckboxes={handleAllCheckboxes}
              rows={(state.displayedItems) || []}
              pagination={setMismatchedDnsPagination()}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              handleChangePage={handleChangePage}
              isEditable
              canUpdate
              canDelete
              // onEdit={onEdit}
              // onDelete={onDelete}
              // themecolors={themecolors}
              serverTimezone={logInUser?.attributes?.timezone || "Asia/Riyadh"}
              timezone={logInUser?.attributes?.timezone || "Asia/Riyadh"}
              // hasAccessOfUpdate={
              //   value === "cashCustomer" ? checkPrivileges("cashinvoiceUpdate") : ""
              // }
              // contractNumber={selectedAccount?.contractNumber || ""}
              // invoiceType={value}
              // downloadInvoice={downloadInvoice}
              // regenerateInvoice={regenerateInvoice}
              // leasing={leasing}
              invoiceRow
              // isSelectedDubious={isSelectedDubious}
              rowDefinition={[
                {
                  id: "deliveryNoteNumber",
                  numeric: false,
                  disablePadding: false,
                  label: props.translate("deliveryNoteNo"),
                },
                {
                  id: "deliveryNoteRefNumber",
                  numeric: false,
                  disablePadding: false,
                  label: props.translate("deliveryNoteRefNumber"),
                },
  
                {
                  id: "workOrderNumber",
                  numeric: false,
                  disablePadding: false,
                  label: props.translate("workOrderNumber"),
                },
                // {
                //   id: "serviceRefNumber",
                //   numeric: false,
                //   disablePadding: false,
                //   label: props.translate("customerRefNum"),
                // },
                {
                  id: "plateNumber",
                  numeric: false,
                  disablePadding: false,
                  label: props.translate("vehicleLicensePlate"),
                },
                {
                  id: "serviceDate",
                  numeric: false,
                  disablePadding: false,
                  label: props.translate("serviceDate"),
                },
                {
                  id: "saleTotalAmount",
                  numeric: false,
                  disablePadding: false,
                  label: props.translate("Amount"),
                },
                {
                  id: "saleVATAmount",
                  numeric: false,
                  disablePadding: false,
                  label: props.translate("VAT Amount"),
                },
                {
                  id: "saleNetAmount",
                  numeric: false,
                  disablePadding: false,
                  label: props.translate("Total Amount"),
                },
                {
                  id: "odometerReading",
                  numeric: false,
                  disablePadding: false,
                  label: props.translate("odometerReading"),
                },

                {
                  id: "creationMode",
                  numeric: false,
                  disablePadding: false,
                  label: props.translate("creationMode"),
                  hide: checkPrivileges("invoiceInvalidView")
                    ? false
                    : true,
                },
                {
                  id: "valid",
                  numeric: false,
                  disablePadding: false,
                  label: props.translate("status"),
                  hide: checkPrivileges("invoiceInvalidView")
                    ? false
                    : true,
                },
                     {
                          id: "reason.attributes",
                          numeric: false,
                          disablePadding: false,
                          label: props.translate("rejectedReason"),
                        },
                {
                  id: "viewDeliveryNote",
                  numeric: false,
                  disablePadding: false,
                  label: props.translate("viewDeliveryNote"),
                  hide: false,
                },
              ]}
            />
          )}
        </Grid>
      </Grid>
      {state.isOpenRejectedDnModal && (
        <ConfirmDialoag
          onCancel={handleCloseRejectedDnModals}
          onOk={handleSubmitRejectionDns}
          title={props.translate('rejectedDns')}
          maxWidth={"lg"}
          disabled={isDisabled}
        >
          <>
            <Box sx={{ maxHeight: 400, overflowY: 'auto', border: '1px solid #ccc', borderRadius: 2, p: 2, width: "800px" }}>
              <Stack direction="row" spacing={2} sx={{ mb: 1, fontWeight: 'bold', borderBottom: '1px solid #ddd', pb: 1 }}>
                <Box sx={{ width: '50%' }}>Delivery Note Number</Box>
                <Box sx={{ width: '50%' }}>Total Amount</Box>
              </Stack>
              {state.selectedIds?.length > 0 ? (
                <>
                  {state.selectedIds.slice(0, state.visibleCount).map((item, index) => (
                    <Stack
                      key={item.id || index}
                      direction="row"
                      spacing={2}
                      sx={{
                        mb: 1,
                        '&:hover': { backgroundColor: '#f5f5f5' },
                        borderBottom: '1px solid #eee',
                        py: 1,
                      }}
                    >
                      <Box sx={{ width: '50%' }}>{item.deliveryNoteNumber}</Box>
                      <Box sx={{ width: '50%' }}>{item?.saleNetAmount || 0}</Box>
                    </Stack>
                  ))}

                  {state.selectedIds?.length > state.visibleCount ? (
                    <Box textAlign="center" mt={2}>
                      <Button variant="outlined" onClick={handleLoadMore}>
                        Load More
                      </Button>
                    </Box>
                  ) : (
                    state.selectedIds?.length > 0 && (
                      <Box textAlign="center" mt={2}>
                        <Typography variant="body2" color="text.secondary">
                          End
                        </Typography>
                      </Box>
                    )
                  )}

                </>
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No delivery notes selected.
                </Typography>
              )}
            </Box>
            <Grid item md={12}>
              {options.map((option) => (
                <Grid item xs={12} key={option.key} sx={{ mb: 1 }} >
                  <div style={{ display: "flex", alignItems: "start" }}>

                    <Checkbox
                      checked={state.selectedOptions?.includes(option.text)}
                      onChange={() => handleCheckboxChange(option)}
                      label={formatLabel(option)}
                      color="primary"
                    />
                  </div>
                </Grid>
              ))}
            </Grid>
            <Grid item md={12}>
              <TextField
                id="message"
                multiline
                label={props.translate("message")}
                placeholder=""
                value={state.rejectionMessage || ""}
                onChange={(e) =>
                  handleRejectionMessage("rejectionMessage", e.target.value)
                }
                variant="outlined"
                margin="dense"
                fullWidth
                sx={{
                  '& .MuiOutlinedInput-root': {
                    padding: 0,
                  },
                }}
              />
            </Grid>
          </>


        </ConfirmDialoag>
      )}
    </>

  );
};

const mapStateToProps = (state) => ({
  ServerSetting: state.ServerSetting,
  logInUser: state.logInUsers,
  themecolors: state.themecolors,
});

export default connect(mapStateToProps)(
  withTranslationWrapper(MismatchedDeliveryNotes)
);
